import { del, get, post } from '../client';

export const documentsApi = {
  list: (params) => get('/documents', { params }),
  presign: (body) => post('/documents/presign', body),
  confirm: (body) => post('/documents/confirm', body),
  remove: (id) => del(`/documents/${id}`),
  swapAadhaar: (body) => post('/documents/aadhaar/swap', body),
};
